module.exports = __webpack_public_path__ + "img/2021.c3a5c0cf.svg";